import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  copyrightedYear:any;
  constructor() { 
this.getCurrentYear();
  }

  ngOnInit() {
  }


  getCurrentYear() {
    this.copyrightedYear=new Date().getFullYear();
  }

}